var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetsCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 84,
    viewBox: "0 0 114 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 84,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin Flow"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -58,
    y: -422,
    width: 360,
    height: 800,
    rx: 12,
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 422201"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2892_239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: -34,
    width: 152,
    height: 118,
    rx: 12,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2303",
    opacity: 0.08,
    cx: 73,
    cy: 73,
    r: 73,
    fill: "url(#paint0_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.6111 26H86.3889C88.9369 26 91 28.4634 91 31.5057V64.4943C91 67.5366 88.9369 70 86.3889 70H83.3466H80.7511H78.0795H51.6111C49.0631 70 47 67.5366 47 64.4943V31.5057C47 28.4634 49.0631 26 51.6111 26Z",
    fill: "url(#paint1_linear_2892_239)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2892_239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.5 37.5H62V41H58.5V37.5Z",
    fill: "#021239",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.5 34V44.5H55V34H65.5ZM63.75 35.75H56.75V42.75H63.75V35.75ZM62 55H58.5V58.5H62V55Z",
    fill: "#021239",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M65.5 51.5V62H55V51.5H65.5ZM56.75 53.25V60.25H63.75V53.25H56.75ZM76 37.5H79.5V41H76V37.5Z",
    fill: "#021239",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73.5 34C72.9477 34 72.5 34.4477 72.5 35V43.5C72.5 44.0523 72.9477 44.5 73.5 44.5H82C82.5523 44.5 83 44.0523 83 43.5V35C83 34.4477 82.5523 34 82 34H73.5ZM80.25 35.75C80.8023 35.75 81.25 36.1977 81.25 36.75V41.75C81.25 42.3023 80.8023 42.75 80.25 42.75H75.25C74.6977 42.75 74.25 42.3023 74.25 41.75V36.75C74.25 36.1977 74.6977 35.75 75.25 35.75H80.25ZM68.125 35.75C68.6082 35.75 69 35.3582 69 34.875C69 34.3918 69.3918 34 69.875 34C70.3582 34 70.75 34.3918 70.75 34.875V36.625C70.75 37.1082 70.3582 37.5 69.875 37.5C69.3918 37.5 69 37.8918 69 38.375V41H68.25C67.6977 41 67.25 40.5523 67.25 40V36.625C67.25 36.1418 67.6418 35.75 68.125 35.75ZM69 44.5V41H69.75C70.3023 41 70.75 41.4477 70.75 42V43.5C70.75 44.0523 70.3023 44.5 69.75 44.5H69ZM65.5 48V47.125C65.5 46.6418 65.8918 46.25 66.375 46.25C66.8582 46.25 67.25 45.8582 67.25 45.375C67.25 44.8918 67.6418 44.5 68.125 44.5H69V47.125C69 47.6082 69.3918 48 69.875 48C70.3582 48 70.75 47.6082 70.75 47.125C70.75 46.6418 71.1418 46.25 71.625 46.25H78.625C79.1082 46.25 79.5 46.6418 79.5 47.125C79.5 47.6082 79.1082 48 78.625 48H73.375C72.8918 48 72.5 48.3918 72.5 48.875C72.5 49.3582 72.1082 49.75 71.625 49.75H68.125C67.6418 49.75 67.25 49.3582 67.25 48.875C67.25 48.3918 66.8582 48 66.375 48H65.5ZM65.5 48V48.75C65.5 49.3023 65.0523 49.75 64.5 49.75H59.375C58.8918 49.75 58.5 49.3582 58.5 48.875C58.5 48.3918 58.1082 48 57.625 48C57.1418 48 56.75 48.3918 56.75 48.875C56.75 49.3582 56.3582 49.75 55.875 49.75C55.3918 49.75 55 49.3582 55 48.875V47.25C55 46.6977 55.4477 46.25 56 46.25H59.375C59.8582 46.25 60.25 46.6418 60.25 47.125C60.25 47.6082 60.6418 48 61.125 48H65.5ZM83 48.75C83 49.3023 82.5523 49.75 82 49.75H81.25V47.125C81.25 46.6418 81.6418 46.25 82.125 46.25C82.6082 46.25 83 46.6418 83 47.125V48.75ZM81.25 49.75H80.5C79.9477 49.75 79.5 50.1977 79.5 50.75V52.25C79.5 52.8023 79.9477 53.25 80.5 53.25H82.125C82.6082 53.25 83 52.8582 83 52.375C83 51.8918 82.6082 51.5 82.125 51.5C81.6418 51.5 81.25 51.1082 81.25 50.625V49.75ZM74.25 50.75C74.25 50.1977 74.6977 49.75 75.25 49.75H76.875C77.3582 49.75 77.75 50.1418 77.75 50.625C77.75 51.1082 77.3582 51.5 76.875 51.5C76.3918 51.5 76 51.8918 76 52.375V53.25H75.25C74.6977 53.25 74.25 52.8023 74.25 52.25V50.75ZM77.75 55V54.25C77.75 53.6977 77.3023 53.25 76.75 53.25H76V55H75.125C74.6418 55 74.25 55.3918 74.25 55.875C74.25 56.3582 73.8582 56.75 73.375 56.75H71.625C71.1418 56.75 70.75 57.1418 70.75 57.625C70.75 58.1082 71.1418 58.5 71.625 58.5H75C75.5523 58.5 76 58.0523 76 57.5V55H77.75ZM77.75 55H82.125C82.6082 55 83 55.3918 83 55.875C83 56.3582 82.6082 56.75 82.125 56.75H80.375C79.8918 56.75 79.5 57.1418 79.5 57.625C79.5 58.1082 79.1082 58.5 78.625 58.5C78.1418 58.5 77.75 58.1082 77.75 57.625V55ZM69.875 53.25C70.3582 53.25 70.75 53.6418 70.75 54.125C70.75 54.6082 71.1418 55 71.625 55C72.1082 55 72.5 54.6082 72.5 54.125V52.5C72.5 51.9477 72.0523 51.5 71.5 51.5H68.125C67.6418 51.5 67.25 51.8918 67.25 52.375C67.25 52.8582 67.6418 53.25 68.125 53.25H69.875Z",
    fill: "#021239",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M67.25 55H69V60.25H76V62H67.25V55ZM83 58.5V62H77.75V60.25H81.25V58.5H83Z",
    fill: "#021239",
    fillOpacity: 0.7
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 397",
    d: "M51 48H87",
    stroke: "#E86D69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    y: -33.5,
    width: 151,
    height: 117,
    rx: 11.5,
    stroke: "url(#paint2_linear_2892_239)",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2892_239",
    x1: 73,
    y1: -44,
    x2: 73,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2892_239",
    x1: 69,
    y1: 26,
    x2: 69,
    y2: 87.4422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4F7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2892_239",
    x1: -38,
    y1: -37,
    x2: 38,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2892_239"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: -34,
    width: 152,
    height: 118,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2892_239"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 34,
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsCardIcon);
export default __webpack_public_path__ + "static/media/AssetsCardIcon.8893eb79b53e4699a6873cd1b1947cd4.svg";
export { ForwardRef as ReactComponent };